import { render, staticRenderFns } from "./OrderModificationRequestModal.vue?vue&type=template&id=2e4790e2"
import script from "./OrderModificationRequestModal.vue?vue&type=script&lang=ts"
export * from "./OrderModificationRequestModal.vue?vue&type=script&lang=ts"
import style0 from "./OrderModificationRequestModal.vue?vue&type=style&index=0&id=2e4790e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports